import React from "react";
import { ReactComponent as FilterSvg } from "../../../assets/icons/Icon/DKT/Filter black.svg";
import { MediaQuery } from "../technical/MediaQuery";

import { OpenableContainer } from "./OpenableContainer";
import { SmallStyledSpinner } from "../ui-elements/StyledSpinner";

import { ActivatedFacets, Facet } from "./types";
import { PLPFacet } from "./PLPFacet";
import { divStyles, iconComponentStyles } from "./ProductListingPageFilter";

type GenericFacetedFilterProps = React.PropsWithChildren<{
  label: React.ReactNode;
  isFetching: boolean;
  facets: Array<Facet>;
  activatedFacets: ActivatedFacets;
  onClick: (facet: Facet) => void;
  openedFilterTabByFilterKey: string | undefined;
}>;

export const GenericFacetedFilter: React.FC<GenericFacetedFilterProps> = ({
  label,
  isFetching: refetching,
  facets,
  activatedFacets,
  onClick,
  openedFilterTabByFilterKey,
  children,
}) => {
  const IconComponent = refetching ? SmallStyledSpinner : FilterSvg;

  return (
    <OpenableContainer label={label} IconComponent={IconComponent}>
      <div css={divStyles}>
        <IconComponent css={iconComponentStyles} />

        {facets.map(facet => {
          return (
            <PLPFacet
              key={facet.__key}
              facet={facet}
              activatedFacetsState={activatedFacets}
              openedFilterTabByFilterKey={openedFilterTabByFilterKey}
              onClick={() => onClick(facet)}
              showActiveFacet={facets.length > 1}
            >
              {children}
            </PLPFacet>
          );
        })}
      </div>

      <MediaQuery atLeast={"md"}>{children}</MediaQuery>
    </OpenableContainer>
  );
};
